import {
  Box,
  Typography,
  Stack,
} from '@mui/material';
import React from 'react';
import { useAlbumIcon, AlbumCategory } from '../useAlbumIcon';
import CustomContainer from '../../CustomContainer';

interface PageHeaderProps {
  title: string;
  description: string;
  category: AlbumCategory;
}

function PageHeader({ title, description, category }: PageHeaderProps) {
  const { icon } = useAlbumIcon(category);

  return (
    <Box>
      <CustomContainer wide>
        <Stack
          spacing={1}
          sx={{
            width: '100%',
            alignItems: { xs: 'center', md: 'flex-start' },
            paddingBottom: {
              xs: 1,
              md: 2,
            },
          }}
        >
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            sx={{ maxWidth: '100%' }}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'primary.main',
                flexShrink: 0,
              }}
            >
              {icon}
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontSize: '18px',
                fontWeight: 700,
                lineHeight: 1.1,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {title}
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{
              display: { xs: 'none', md: 'block' },
              color: 'text.secondary',
              fontSize: '14px',
              lineHeight: 1.5,
            }}
          >
            {description}
          </Typography>
        </Stack>
      </CustomContainer>
    </Box>
  );
}

export default PageHeader;
